export default class AddToCartError extends Error {
  constructor(...args) {
    super(...args)
    Error.captureStackTrace && Error.captureStackTrace(this, AddToCartError);
  }
}
